import { render, staticRenderFns } from "./CategoryChip.vue?vue&type=template&id=1a0801bd&scoped=true&"
import script from "./CategoryChip.vue?vue&type=script&lang=js&"
export * from "./CategoryChip.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChip.vue?vue&type=style&index=0&id=1a0801bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0801bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})
